module.exports = __webpack_public_path__ + "img/pat-desc.6081183a.png";